import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installGoogleMapsBootstrap } from './app/shared/google-maps-bootstrap';

// Was an inline <script> in index.html; runs before bootstrap exactly as before, key now from web secrets.
installGoogleMapsBootstrap(environment.googleMapsApiKey);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));

